<template>
	<div class="bulk-import-container">
		<el-form :model="form" ref="form">
			<el-form-item label="导入文件">
				<upload-excel :on-success="handleSuccess" :before-upload="beforeUpload"></upload-excel>
				<div class="selected-file" v-if="file">已选择：{{ file.name }}</div>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="submitUpload" :loading="loading" :disabled="!file">确定导入</el-button>
				<el-button @click="$emit('closeDialog')">取消</el-button>
			</el-form-item>
		</el-form>

		<div class="tips-container">
			<div class="tips-title">导入说明：</div>
			<div class="tips-content">
				<p>1. 请使用Excel格式文件进行导入，支持.xlsx、.xls格式。</p>
				<p>2. 文件大小请控制在5MB以内。</p>
				<p>3. 请按照模板格式填写数据，确保必填字段完整。</p>
				<p>
					4.
					<el-button type="text" @click="downloadTemplate">下载导入模板</el-button>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
	import UploadExcel from '@/components/UploadExcel';
	// import * as clueApi from '@/api/clueNew'
	import axios from 'axios';
	import SettingMer from '@/utils/settingMer';

	export default {
		name: 'BulkImport',
		components: { UploadExcel },
		data() {
			return {
				form: {},
				loading: false,
				file: null,
				// 错误fieldName匹配列表
				fieldNameList: [
					{
						name: '客户姓名',
						fieldName: 'customerName',
					},
					{
						name: '联系方式',
						fieldName: 'contactInfo',
					},
					{
						name: '需求类型',
						fieldName: 'demandTypeName',
					},
					{
						name: '消费意愿',
						fieldName: 'consumptionWillingnessName',
					},
					{
						name: '线索类型',
						fieldName: 'leadTypeName',
					},
					{
						name: '线索来源',
						fieldName: 'leadSource',
					},
					{
						name: '下次跟进时间',
						fieldName: 'nextFollowUpTime',
					},
					{
						name: '详细地址',
						fieldName: 'detailedAddress',
					},
					{
						name: '备注',
						fieldName: 'remarks',
					},
					{
						name: '本次跟进目的',
						fieldName: 'direction',
					},
					{
						name: '本次跟进结果',
						fieldName: 'result',
					},
					{
						name: '跟进时间',
						fieldName: 'followUpTime',
					},
					{
						name: '跟进人',
						fieldName: 'followUpName',
					},
				],
			};
		},
		methods: {
			handleSuccess(file) {
				// console.log('Selected file:', file.name)
				this.file = file;
			},
			beforeUpload(file) {
				const isExcel = /\.(xlsx|xls)$/.test(file.name.toLowerCase());
				const isLt5M = file.size / 1024 / 1024 < 5;

				if (!isExcel) {
					this.$message.error('上传文件只能是Excel格式!');
					return false;
				}
				if (!isLt5M) {
					this.$message.error('上传文件大小不能超过 5MB!');
					return false;
				}
				return true;
			},
			submitUpload() {
				if (!this.file) {
					this.$message.warning('请先选择Excel文件');
					return;
				}

				this.loading = true;

				// 创建FormData对象来发送文件
				const formData = new FormData();
				formData.append('file', this.file);

				// 调用API导入数据，直接传递FormData
				// clueApi.importClues(formData)
				//   .then(res => {
				//     if (res.length > 0) {
				//       const errorHtml = this.getErrorInfo(res)
				//       // 显示错误信息
				//       this.$notify({
				//         title: '导入错误',
				//         dangerouslyUseHTMLString: true,
				//         message: errorHtml,
				//         type: 'error',
				//         duration: 0
				//       });
				//     } else {
				//       this.$message.success('导入成功')
				//       this.$emit('importSuccess')
				//       this.$emit('closeDialog')
				//     }
				//   })
				//   .catch(err => {
				//     console.error('导入失败', err)
				//     // this.$message.error('导入失败，请检查数据格式是否正确')
				//   })
				//   .finally(() => {
				//     this.loading = false
				//   })
			},
			getErrorInfo(res) {
				// 处理错误信息，将错误信息转换为用户友好的提示
				let errorMessages = [];

				res.forEach(error => {
					// 查找对应的字段中文名称
					const fieldInfo = this.fieldNameList.find(item => item.fieldName === error.fieldName);
					const fieldName = fieldInfo ? fieldInfo.name : error.fieldName;

					// 处理每个错误消息
					error.errorMsg.forEach(msg => {
						const errorMessage = `表格第${error.rowIndex}行的${fieldName},${msg}`;
						errorMessages.push(errorMessage);
					});
				});

				// 创建HTML片段
				const errorHtml = errorMessages.map(msg => `<div>${msg}</div>`).join('');

				return errorHtml;
			},
			downloadTemplate() {
				axios({
					method: 'post',
					url: `${SettingMer.apiBaseURL}/shop/clueNew/downloadTemplate`,
					headers: {
						'Content-Type': 'application/json',
						'Authori-Zation': this.$store.getters.token,
					},
					responseType: 'blob',
				}).then(res => {
					// 创建blob对象
					const blob = new Blob([res.data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					});

					// 创建下载链接
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.style.display = 'none';
					link.href = url;
					link.setAttribute('download', '线索跟进记录导入模板.xlsx'); // 设置下载文件名

					// 将链接添加到body
					document.body.appendChild(link);

					// 触发点击下载
					link.click();

					// 清理DOM
					document.body.removeChild(link);

					// 释放URL对象
					window.URL.revokeObjectURL(url);

					this.$message({
						message: '模板下载成功',
						type: 'success',
					});
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.bulk-import-container {
		padding: 20px;

		.selected-file {
			margin-top: 10px;
			color: #606266;
			font-size: 14px;
		}

		.tips-container {
			margin-top: 20px;
			border-top: 1px dashed #ebeef5;
			padding-top: 15px;

			.tips-title {
				font-weight: bold;
				margin-bottom: 10px;
				color: #303133;
			}

			.tips-content {
				color: #606266;
				line-height: 1.8;

				a {
					color: #409eff;
					text-decoration: none;
				}
			}
		}
	}
</style>
